import { render, staticRenderFns } from "./Entidad.vue?vue&type=template&id=64705400&"
import script from "./Entidad.vue?vue&type=script&lang=js&"
export * from "./Entidad.vue?vue&type=script&lang=js&"
import style0 from "./Entidad.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports